import { createAsyncThunk } from '@reduxjs/toolkit';
import { filesUploadService } from '../../services';

const getFiles = createAsyncThunk(
    'filesUpload/getFiles',
    async (payload, thunkAPI) => {
        try {
            const response = await filesUploadService.getFiles(
                payload.companyId,
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const uploadFiles = createAsyncThunk(
    'filesUpload/uploadFiles',
    async (payload, thunkAPI) => {
        try {
            const response = await filesUploadService.uploadFiles(
                payload.data,
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteFiles = createAsyncThunk(
    'filesUpload/deleteFiles',
    async (payload, thunkAPI) => {
        try {
            const response = await filesUploadService.deleteFiles(
                payload.companyId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);



export { 
    getFiles,
    uploadFiles,
    deleteFiles
};